import { SET_APPLY_DSR_BRANDING } from '../../actions/dsr-actions-types'

const INITIAL_STATE_SET_APPLY_DSR_BRANDING = { results: '' }

export function setDsrApplyBrandingReducer(state = INITIAL_STATE_SET_APPLY_DSR_BRANDING, action) {
    switch (action.type) {
        case SET_APPLY_DSR_BRANDING:
            return { results: action.payload }
        default:
            return state;
    }
}